import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';
import SecurityBadges from '../SecurityBadges';

const Footer = () => {
    return (
        <div className="bg-neutral-900">
            <div className="bg-neutral-900 px-8 pt-32 pb-16 relative z-0">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="flex flex-col gap-3">
                            <Logo width="208" height="32" />
                            <p className="!text-stone-300 text-xs font-medium font-['Inter'] leading-5">The remote hire that connects customers and staff around the clock.</p>
                        </div>
                        <div className="flex gap-8">
                            <div className="flex flex-col gap-3">
                                <div className="text-gray-50 text-base font-bold font-['Inter']">Product</div>
                                <div className="flex flex-col gap-2">
                                    <a href="#features" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Features</a>
                                    <Link to="/signup" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Join Waitlist</Link>
                                    <a href="https://remote-assistant.io" target="_blank" rel="noopener noreferrer" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">For Developers <i className="fa fa-external-link text-stone-500" style={{fontSize: '8px'}}></i></a>
                                </div>
                            </div>
                                <div className="flex flex-col gap-3">
                                <div className="text-gray-50 text-base font-bold font-['Inter']">Company</div>
                                <div className="flex flex-col gap-2">
                                    <Link to="/about" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">About</Link>
                                    <a href="https://blog.remote-assistant.ai" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Blog</a>
                                    <Link to="/contact" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Contact</Link>
                                    <Link to="/privacy" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Privacy</Link>
                                    <Link to="/toc" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Terms</Link>
                                    <Link to="/trust-and-safety" className="text-stone-300 text-xs font-medium font-['Inter'] hover:text-white transition-colors">Trust & Safety</Link>
                                </div>
                            </div>
                        </div>
                        <SecurityBadges showInProgress={true} darkTheme={true} />
                    </div>
                </div>
            </div>

            <div className="bg-neutral-900 border-t border-gray-700 px-8 py-8">
                <div className="max-w-7xl mx-auto text-center">
                    <p className="!text-stone-300 text-sm font-medium font-['Inter']">© 2026 Remote Assistant. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
